export default {
	'set-home-location': 'تعيين موقع منزل',
	'generate-qr-all': 'توليد QR لكل الأسطر',
	'qr-code': 'QR كود',

	'add-passenger': 'إضافة راكب',
	'edit-passenger': 'تعديل راكب',
	// 'نقل مؤقت إلى باص'
	'student-temporarily-transferred-from-bus-to-bus': 'نقل طالب مؤقتا من باص لباص'
}